// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface CreditTypeDTO extends EntitySelectorDTO { 
	id: string | null;
	displayOrder: number;
	name: string | null;
}

const CreditTypeDTO = {
    className: 'CreditTypeDTO',
    create: (initValues?: Partial<CreditTypeDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			displayOrder: 0,
			name: "",
        },
        initValues);
    },
	id: 'id',
	displayOrder: 'displayOrder',
	name: 'name',
};

export default CreditTypeDTO;